import "./styles.css";
import Note from "./noteComponent";
import { useProvider } from "./context";
import Search from "./search";
import Sidebar from "./sidebar";

export default function App() {
  const { Data, filterBy } = useProvider();
  console.log(Data);
  function Filter(Data) {
    return Data.filter((item) =>
      filterBy ? item.desc.includes(filterBy) : true
    );
  }
  const filteredData = Filter(Data);

  return (
    <div className="App">
      <div className="wrapper">
        <Sidebar />
        <div>
          <Search />
          <header className="header">Notes</header>
          <div className="notes">
            {filteredData.map((item) => {
              return <Note data={item} />;
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
